export const api = {
    // host:  process.env.REACT_APP_API_URL,
    host: 'https://api.ftf.adtdev.pro/',
    main: {
        authorization: 'api/v1/auth',
        authorizationWidget: 'api/v1/auth/telegram/callback',
        authorizationGoogleWidget: 'api/v1/auth/google/callback',
        classicRegistration: 'api/v1/auth/register/via-email',
        classicLogin: 'api/v1/auth/login/via-email',
        resetPassword: ''
    },
    cabinet: {
        user: 'api/v1/user',
        events: 'api/v1/events',
        choiceEvent: 'api/v1/select-event',
        mainData: 'api/v1/event-selected',
        roadmap: 'api/v1/roadmap',
        leaderboard: 'api/v1/leader-board',
        matrix: 'api/v1/laps',
        referrals: 'api/v1/referrals',
        referralsMain: 'api/v1/referrals/main',
        contestWinners: 'api/v1/contest/laps',
        contestWinnersData: 'api/v1/contest/top',
        refCode: 'api/v1/set-partner',
        sendConnectedWallet: 'api/v1/wallet/set',
        tokenCourse: 'api/v1/token/rate',
        sendWalletAT: 'api/v1/wallet/check-replenishment',
        receiveUsdtWallet: 'api/v1/receive-wallet',
        contestInfo: 'api/v1/contest/main',
        changePassword: 'api/v1/profile/change-password',
        changeAvatar: 'api/v1/profile/change-avatar',
        transactions: 'api/v1/transactions',
        buyRequest: 'api/v1/buy-requests'
    }
}